module.exports = __webpack_public_path__ + "img/phone-profile.9138e16c.webp";